/* July Mode Nav v3: desktop mega menus + mobile drawer. Keyboard per V3 spec. */
(function(){
  function init(root){
    if(root.dataset.nv3Ready)return; root.dataset.nv3Ready='1';
    var triggers=[].slice.call(root.querySelectorAll('[data-nv3-top] > li > [data-nv3-trigger]'));
    var open=null, hoverTimer=null;
    function panelOf(t){var id=t.getAttribute('aria-controls');return id?document.getElementById(id):null}
    function close(t,focus){ if(!t)return; var p=panelOf(t); t.setAttribute('aria-expanded','false'); if(p)p.hidden=true; if(open===t)open=null; if(focus)t.focus(); }
    function show(t){ if(open&&open!==t)close(open); var p=panelOf(t); if(!p)return; t.setAttribute('aria-expanded','true'); p.hidden=false; open=t; }
    function links(p){return [].slice.call(p.querySelectorAll('a[href],button')).filter(function(e){return e.offsetParent!==null})}
    triggers.forEach(function(t,i){
      var li=t.parentElement, p=panelOf(t);
      if(p){
        t.addEventListener('click',function(e){e.preventDefault(); t.getAttribute('aria-expanded')==='true'?close(t):show(t)});
        li.addEventListener('mouseenter',function(){ if(!matchMedia('(hover:hover)').matches)return; clearTimeout(hoverTimer); hoverTimer=setTimeout(function(){show(t)},80)});
        li.addEventListener('mouseleave',function(){ clearTimeout(hoverTimer); hoverTimer=setTimeout(function(){ if(open===t)close(t)},150)});
        p.addEventListener('keydown',function(e){
          var l=links(p), k=l.indexOf(document.activeElement);
          if(e.key==='ArrowDown'){e.preventDefault(); (l[k+1]||l[0]).focus()}
          else if(e.key==='ArrowUp'){e.preventDefault(); (k<=0?t:l[k-1]).focus()}
        });
      } else {
        li.addEventListener('mouseenter',function(){ if(open&&matchMedia('(hover:hover)').matches)close(open)});
      }
      t.addEventListener('keydown',function(e){
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault(); var n=triggers[(i+(e.key==='ArrowRight'?1:-1)+triggers.length)%triggers.length]; if(open)close(open); n.focus()}
        else if(e.key==='ArrowDown'&&p){e.preventDefault(); show(t); var l=links(p); if(l[0])l[0].focus()}
      });
    });
    root.addEventListener('keydown',function(e){ if(e.key==='Escape'&&open){ e.preventDefault(); close(open,true) } });
    document.addEventListener('click',function(e){ if(open&&!root.contains(e.target))close(open) });
    root.addEventListener('focusout',function(){ setTimeout(function(){ if(open&&!root.contains(document.activeElement))close(open) },0) });

    // Mobile drawer
    var drawer=root.querySelector('[data-nv3-drawer]'), scrim=root.querySelector('[data-nv3-scrim]'), opener=root.querySelector('[data-nv3-drawer-open]');
    function dOpen(){ drawer.hidden=false; scrim.hidden=false; opener.setAttribute('aria-expanded','true'); document.documentElement.style.overflow='hidden'; var c=drawer.querySelector('[data-nv3-drawer-close]'); c&&c.focus() }
    function dClose(){ drawer.hidden=true; scrim.hidden=true; opener.setAttribute('aria-expanded','false'); document.documentElement.style.overflow=''; opener.focus() }
    if(drawer&&opener){
      opener.addEventListener('click',dOpen);
      drawer.querySelector('[data-nv3-drawer-close]').addEventListener('click',dClose);
      scrim.addEventListener('click',dClose);
      drawer.addEventListener('keydown',function(e){
        if(e.key==='Escape'){e.preventDefault(); dClose(); return}
        if(e.key==='Tab'){ var f=links(drawer); if(!f.length)return; if(e.shiftKey&&document.activeElement===f[0]){e.preventDefault();f[f.length-1].focus()} else if(!e.shiftKey&&document.activeElement===f[f.length-1]){e.preventDefault();f[0].focus()} }
      });
      [].forEach.call(drawer.querySelectorAll('[data-nv3-proxy]'),function(b){
        b.addEventListener('click',function(e){
          var kind=b.getAttribute('data-nv3-proxy');
          if(kind==='cart'&&!document.querySelector('cart-drawer'))return; // no drawer: normal /cart link, same as current header
          e.preventDefault(); drawer.hidden=true; scrim.hidden=true; opener.setAttribute('aria-expanded','false'); document.documentElement.style.overflow='';
          var t=kind==='search'?root.querySelector('details-modal.header__search summary'):document.getElementById('cart-icon-bubble');
          if(t)setTimeout(function(){t.click()},0); // defer: same-tick click is caught by DetailsModal.onBodyClick and closes it
        });
      });
      [].forEach.call(drawer.querySelectorAll('[data-nv3-acc]'),function(b){
        b.addEventListener('click',function(){ var p=document.getElementById(b.getAttribute('aria-controls')); var x=b.getAttribute('aria-expanded')==='true'; b.setAttribute('aria-expanded',String(!x)); p.hidden=x });
      });
    }
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-nv3]'),init) }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
})();
